"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * This script closes the accordion elements on init
 */
var waitForElement_1 = require("../../../../../ww_project/Resources/Private/app/helpers/waitForElement");
var CompusoftLastMinuteAccordion = /** @class */ (function () {
    function CompusoftLastMinuteAccordion() {
        var _this = this;
        this.isRunning = true;
        (0, waitForElement_1.waitForElement)('#LastminuteWrapper #csobLastMinuteContainer').then(function (element) {
            // Init headlines on first page load
            _this.initAccordions(element);
            // Listen to DOM changes if compusoft decides to randomly update the table content
            var config = { attributes: false, childList: true, subtree: false };
            var callback = function (mutationList) {
                for (var _i = 0, mutationList_1 = mutationList; _i < mutationList_1.length; _i++) {
                    var mutation = mutationList_1[_i];
                    if (mutation.type === 'childList') {
                        _this.initAccordions(element);
                    }
                }
            };
            var observer = new MutationObserver(callback);
            observer.observe(element, config);
        });
    }
    CompusoftLastMinuteAccordion.prototype.initAccordions = function (parent) {
        var _this = this;
        if (!this.isRunning)
            return;
        this.dealItems = parent.querySelectorAll('.deal-item');
        this.dealItems.forEach(function (item) {
            item.classList.remove('visible');
        });
        this.isRunning = false;
        setTimeout(function () {
            _this.isRunning = true;
        }, 500);
    };
    return CompusoftLastMinuteAccordion;
}());
exports.default = CompusoftLastMinuteAccordion;
